// ----------------------------------------------------------------------- imports internos
import { Icono } from "../layout/Icono";

/* Lo que ve quien entra a una pantalla sin el permiso: una puerta cerrada y
 * nada más. No dice qué llave falta ni a quién pedírsela (Igna, 06/10). */
const PuertaCerrada = () => (
  <div className="panel-aviso puerta-cerrada">
    <Icono nombre="puerta" size={56} />
    <h3>No podés pasar</h3>
  </div>
);

export default PuertaCerrada;
